var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotorRacingHelmet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13404_66428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6659 8.13206C14.6861 7.15341 14.4905 6.18234 14.093 5.28781C13.6955 4.39328 13.106 3.59726 12.3662 2.95628C11.6264 2.31529 10.7545 1.84509 9.8125 1.57906C8.87049 1.31303 7.88146 1.2577 6.91566 1.41701C5.94985 1.57632 5.03098 1.94635 4.22431 2.50082C3.41765 3.05529 2.74297 3.7806 2.24823 4.62521C1.75348 5.46983 1.45079 6.41303 1.36167 7.38782C1.27255 8.36261 1.39918 9.34506 1.73257 10.2654C1.86591 10.5987 2.26591 10.9987 2.59924 11.1321L11.3992 14.5321C11.7326 14.6654 12.1992 14.5321 12.4659 14.3321L14.1992 12.5987C14.4659 12.3321 14.6659 11.7987 14.6659 11.4654V8.13206Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5318 11.9975L7.53176 9.33086C7.23433 9.22156 6.98422 9.00706 6.82597 8.72558C6.66772 8.44409 6.61161 8.11389 6.66763 7.79378C6.72365 7.47367 6.88816 7.18443 7.13187 6.97757C7.37558 6.77071 7.68266 6.65966 7.99842 6.6642H14.5318",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13404_66428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorRacingHelmet);
export default __webpack_public_path__ + "static/media/motor_racing_helmet.8f120daaabc696dd77a56fce00b588de.svg";
export { ForwardRef as ReactComponent };